//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';

export const ContentDrawerTrackingIdPrefix: TrackingIdPrefix =
  'content-drawer-';

export const ContentDrawerTrackingIds = {
  APPLY_LABELS: `${ContentDrawerTrackingIdPrefix}apply-labels`,
  CANCEL_UPLOAD: `${ContentDrawerTrackingIdPrefix}cancel-upload`,
  CLOSE_ALL_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}close-all-labels-modal`,
  CLOSE_DELETE_LABEL_CONFIRMATION: `${ContentDrawerTrackingIdPrefix}close-delete-label-confirmation`,
  CLOSE_DELETE_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}close-delete-labels-modal`,
  CLOSE_DRAWER: `${ContentDrawerTrackingIdPrefix}close`,
  CLOSE_MANAGE_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}close-manage-labels-modal`,
  CLOSE_PREVIEW_MODAL: `${ContentDrawerTrackingIdPrefix}close-preview-modal`,
  CLOSE_UPDATE_LABEL_CONFIRMATION: `${ContentDrawerTrackingIdPrefix}close-update-label-confirmation`,
  CLOSE_UPDATE_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}close-update-labels-modal`,
  DELETE_LABEL: `${ContentDrawerTrackingIdPrefix}delete-label`,
  DELETE_LABEL_CONFIRMATION: `${ContentDrawerTrackingIdPrefix}delete-label-confirmation`,
  LABEL_CHECKBOX: `${ContentDrawerTrackingIdPrefix}label-checkbox`,
  LABELS_FIELDSET: `${ContentDrawerTrackingIdPrefix}labels-fieldset`,
  OPEN_ALL_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}open-all-labels-modal`,
  OPEN_MANAGE_LABELS_MODAL: `${ContentDrawerTrackingIdPrefix}open-manage-labels-modal`,
  PREVIEW_MEDIA_ITEM: `${ContentDrawerTrackingIdPrefix}preview-media-item`,
  RESET_FILTERS: `${ContentDrawerTrackingIdPrefix}reset-filters`,
  SEARCH_LABELS: `${ContentDrawerTrackingIdPrefix}search-labels`,
  SEARCH_PRODUCTS: `${ContentDrawerTrackingIdPrefix}search-products`,
  SEARCH_USERS: `${ContentDrawerTrackingIdPrefix}search-users`,
  SELECT_MEDIA_ITEM: `${ContentDrawerTrackingIdPrefix}select-media-item`,
  SORT_LABELS: `${ContentDrawerTrackingIdPrefix}sort-labels`,
  TOGGLE_FILTERS: `${ContentDrawerTrackingIdPrefix}toggle-filters`,
  UPDATE_LABEL: `${ContentDrawerTrackingIdPrefix}update-label`,
  UPDATE_LABEL_CONFIRMATION: `${ContentDrawerTrackingIdPrefix}update-label-confirmation`,
  UPLOAD_MEDIA: `${ContentDrawerTrackingIdPrefix}upload-media`,
  USE_SELECTED_MEDIA: `${ContentDrawerTrackingIdPrefix}use-selected-media`,
};

// Universal image actions tagging permission
export const IMAGE_TAGGING_PERMISSION = 'universal_image_actions:tagging';

// file size limit for media import/upload
export const NORMAL_VIDEO_IMPORT_LIMIT_MB = 200;
export const LARGE_VIDEO_IMPORT_LIMIT_MB = 2000;

export const BYTES_PER_MB = 1000000;

export const labelsQueryKeys = [
  QueryKeyConstants.MediaFilters,
  QueryKeyConstants.MediaFiltersLabels,
  QueryKeyConstants.MediaFiltersLabelsManage,
] as const;

export const manageLabelsQueryKeys = [
  QueryKeyConstants.MediaFilters,
  QueryKeyConstants.MediaFiltersLabels,
] as const;
